import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { useTranslation } from '@ibk/shared-translation';
import { AppDomain, FeatureFlagUseCase, ProductStatus } from '@ibk/shared-types';
import { Icon } from '../../Icon';
import ProductCard from '../ProductCard';
const numberFormat = (balance) => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        minimumFractionDigits: 2,
    }).format(balance);
};
export default function ContabilidadeDigitalCard({ id, status, onClick, 'data-testid': dataTestId, metaData, ...props }) {
    const { t } = useTranslation();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const appDomain = useSelector(selectAppDomain);
    const isPluggyOthersBanksBalanceFeatureEnabled = isFeatureFlagWhiteListed(appDomain === AppDomain.EMPRESA
        ? FeatureFlagUseCase.PLUGGY_OTHER_BANKS_BALANCE_CLIENT
        : FeatureFlagUseCase.PLUGGY_OTHER_BANKS_BALANCE_ACCOUNTANT);
    const showBalance = useAppSelector(state => state.showBalance.showBalance);
    const getCardData = useMemo(() => {
        if (isPluggyOthersBanksBalanceFeatureEnabled) {
            let icon = 'contentInvert';
            let title = t('products.contabilidade-digital-card-title');
            let contractedData = typeof metaData?.balance === 'number' ? numberFormat(metaData.balance) : '0,00';
            contractedData = showBalance ? contractedData : '*****';
            let prefix = 'R$';
            if (status !== ProductStatus.CONTRACTED || !metaData?.connectedAccounts) {
                icon = 'content';
                title = t('products.contabilidade-digital');
                contractedData = typeof metaData?.connectedAccounts === 'number' ? metaData.connectedAccounts.toString() : '0';
                prefix = t('products.status.connected-accounts');
            }
            const statusElement = status === ProductStatus.CONTRACTED ? (_jsxs(_Fragment, { children: [prefix, _jsxs("strong", { "data-testid": `product-card-contracted-data-${id}`, children: ["\u00A0", contractedData] })] })) : null;
            return {
                icon,
                title,
                statusElement,
            };
        }
        const icon = status === ProductStatus.CONTRACTED ? 'contentInvert' : 'content';
        const title = t('products.contabilidade-digital');
        const contractedData = typeof metaData?.connectedAccounts === 'number' ? metaData.connectedAccounts.toString() : '';
        const statusElement = status === ProductStatus.CONTRACTED ? (_jsxs(_Fragment, { children: [t('products.status.connected-accounts'), _jsxs("strong", { "data-testid": `product-card-contracted-data-${id}`, children: ["\u00A0", contractedData] })] })) : null;
        return {
            icon,
            title,
            statusElement,
        };
    }, [isPluggyOthersBanksBalanceFeatureEnabled, metaData, status, t, id, showBalance]);
    const { icon, title, statusElement } = getCardData;
    return (_jsx(ProductCard, { ...props, id: id, title: title, icon: _jsx(Icon, { name: icon }), status: status, onClick: onClick, "data-testid": dataTestId ?? `contabilidade-digital-card-${id}`, statusElement: statusElement }));
}
